export default {
      id: "ic-show-pass-usage",
      viewBox: "0 0 22 22",
      url: "/" + "images/icons.3.109.2.svg#ic-show-pass-usage",
      toString: function () {
        return this.url;
      }
    }